export const countries = [
	{ code: 'AD', label: 'Andorra', phone: '376' , suggested: 0 },
	{ code: 'AE', label: 'United Arab Emirates', phone: '971' , suggested: 0 },
	{ code: 'AF', label: 'Afghanistan', phone: '93' , suggested: 0 },
	{ code: 'AG', label: 'Antigua and Barbuda', phone: '1-268' , suggested: 0 },
	{ code: 'AI', label: 'Anguilla', phone: '1-264' , suggested: 0 },
	{ code: 'AL', label: 'Albania', phone: '355' , suggested: 0 },
	{ code: 'AM', label: 'Armenia', phone: '374' , suggested: 0 },
	{ code: 'AO', label: 'Angola', phone: '244' , suggested: 0 },
	{ code: 'AQ', label: 'Antarctica', phone: '672' , suggested: 0 },
	{ code: 'AR', label: 'Argentina', phone: '54' , suggested: 0 },
	{ code: 'AS', label: 'American Samoa', phone: '1-684' , suggested: 0 },
	{ code: 'AT', label: 'Austria', phone: '43' , suggested: 0 },
	{ code: 'AU', label: 'Australia', phone: '61', suggested: 0 },
	{ code: 'AW', label: 'Aruba', phone: '297' , suggested: 0 },
	{ code: 'AX', label: 'Alland Islands', phone: '358' , suggested: 0 },
	{ code: 'AZ', label: 'Azerbaijan', phone: '994' , suggested: 0 },
	{ code: 'BA', label: 'Bosnia and Herzegovina', phone: '387' , suggested: 0 },
	{ code: 'BB', label: 'Barbados', phone: '1-246' , suggested: 0 },
	{ code: 'BD', label: 'Bangladesh', phone: '880' , suggested: 0 },
	{ code: 'BE', label: 'Belgium', phone: '32' , suggested: 0 },
	{ code: 'BF', label: 'Burkina Faso', phone: '226' , suggested: 0 },
	{ code: 'BG', label: 'Bulgaria', phone: '359' , suggested: 0 },
	{ code: 'BH', label: 'Bahrain', phone: '973' , suggested: 0 },
	{ code: 'BI', label: 'Burundi', phone: '257' , suggested: 0 },
	{ code: 'BJ', label: 'Benin', phone: '229' , suggested: 0 },
	{ code: 'BL', label: 'Saint Barthelemy', phone: '590' , suggested: 0 },
	{ code: 'BM', label: 'Bermuda', phone: '1-441' , suggested: 0 },
	{ code: 'BN', label: 'Brunei Darussalam', phone: '673' , suggested: 0 },
	{ code: 'BO', label: 'Bolivia', phone: '591' , suggested: 0 },
	{ code: 'BR', label: 'Brazil', phone: '55' , suggested: 0 },
	{ code: 'BS', label: 'Bahamas', phone: '1-242' , suggested: 0 },
	{ code: 'BT', label: 'Bhutan', phone: '975' , suggested: 0 },
	{ code: 'BV', label: 'Bouvet Island', phone: '47' , suggested: 0 },
	{ code: 'BW', label: 'Botswana', phone: '267' , suggested: 0 },
	{ code: 'BY', label: 'Belarus', phone: '375' , suggested: 0 },
	{ code: 'BZ', label: 'Belize', phone: '501' , suggested: 0 },
	{ code: 'CA', label: 'Canada', phone: '1', suggested: 0 },
	{ code: 'CC', label: 'Cocos (Keeling) Islands', phone: '61' , suggested: 0 },
	{ code: 'CD', label: 'Congo, Democratic Republic of the', phone: '243' , suggested: 0 },
	{ code: 'CF', label: 'Central African Republic', phone: '236' , suggested: 0 },
	{ code: 'CG', label: 'Congo, Republic of the', phone: '242' , suggested: 0 },
	{ code: 'CH', label: 'Switzerland', phone: '41' , suggested: 0 },
	{ code: 'CI', label: "Cote d'Ivoire", phone: '225' , suggested: 0 },
	{ code: 'CK', label: 'Cook Islands', phone: '682' , suggested: 0 },
	{ code: 'CL', label: 'Chile', phone: '56' , suggested: 0 },
	{ code: 'CM', label: 'Cameroon', phone: '237' , suggested: 0 },
	{ code: 'CN', label: 'China', phone: '86' , suggested: 0 },
	{ code: 'CO', label: 'Colombia', phone: '57' , suggested: 0 },
	{ code: 'CR', label: 'Costa Rica', phone: '506' , suggested: 0 },
	{ code: 'CU', label: 'Cuba', phone: '53' , suggested: 0 },
	{ code: 'CV', label: 'Cape Verde', phone: '238' , suggested: 0 },
	{ code: 'CW', label: 'Curacao', phone: '599' , suggested: 0 },
	{ code: 'CX', label: 'Christmas Island', phone: '61' , suggested: 0 },
	{ code: 'CY', label: 'Cyprus', phone: '357' , suggested: 0 },
	{ code: 'CZ', label: 'Czech Republic', phone: '420' , suggested: 0 },
	{ code: 'DE', label: 'Germany', phone: '49', suggested: 1 },
	{ code: 'DJ', label: 'Djibouti', phone: '253' , suggested: 0 },
	{ code: 'DK', label: 'Denmark', phone: '45' , suggested: 0 },
	{ code: 'DM', label: 'Dominica', phone: '1-767' , suggested: 0 },
	{ code: 'DO', label: 'Dominican Republic', phone: '1-809' , suggested: 0 },
	{ code: 'DZ', label: 'Algeria', phone: '213' , suggested: 0 },
	{ code: 'EC', label: 'Ecuador', phone: '593' , suggested: 0 },
	{ code: 'EE', label: 'Estonia', phone: '372' , suggested: 0 },
	{ code: 'EG', label: 'Egypt', phone: '20' , suggested: 0 },
	{ code: 'EH', label: 'Western Sahara', phone: '212' , suggested: 0 },
	{ code: 'ER', label: 'Eritrea', phone: '291' , suggested: 0 },
	{ code: 'ES', label: 'Spain', phone: '34' , suggested: 0 },
	{ code: 'ET', label: 'Ethiopia', phone: '251' , suggested: 0 },
	{ code: 'FI', label: 'Finland', phone: '358' , suggested: 0 },
	{ code: 'FJ', label: 'Fiji', phone: '679' , suggested: 0 },
	{ code: 'FK', label: 'Falkland Islands (Malvinas)', phone: '500' , suggested: 0 },
	{ code: 'FM', label: 'Micronesia, Federated States of', phone: '691' , suggested: 0 },
	{ code: 'FO', label: 'Faroe Islands', phone: '298' , suggested: 0 },
	{ code: 'FR', label: 'France', phone: '33', suggested: 2 },
	{ code: 'GA', label: 'Gabon', phone: '241' , suggested: 0 },
	{ code: 'GB', label: 'United Kingdom', phone: '44' , suggested: 0 },
	{ code: 'GD', label: 'Grenada', phone: '1-473' , suggested: 0 },
	{ code: 'GE', label: 'Georgia', phone: '995' , suggested: 0 },
	{ code: 'GF', label: 'French Guiana', phone: '594' , suggested: 0 },
	{ code: 'GG', label: 'Guernsey', phone: '44' , suggested: 0 },
	{ code: 'GH', label: 'Ghana', phone: '233' , suggested: 0 },
	{ code: 'GI', label: 'Gibraltar', phone: '350' , suggested: 0 },
	{ code: 'GL', label: 'Greenland', phone: '299' , suggested: 0 },
	{ code: 'GM', label: 'Gambia', phone: '220' , suggested: 0 },
	{ code: 'GN', label: 'Guinea', phone: '224' , suggested: 0 },
	{ code: 'GP', label: 'Guadeloupe', phone: '590' , suggested: 0 },
	{ code: 'GQ', label: 'Equatorial Guinea', phone: '240' , suggested: 0 },
	{ code: 'GR', label: 'Greece', phone: '30' , suggested: 0 },
	{
		code: 'GS',
		label: 'South Georgia and the South Sandwich Islands',
		phone: '500',
		suggested: 0
	},
	{ code: 'GT', label: 'Guatemala', phone: '502' , suggested: 0 },
	{ code: 'GU', label: 'Guam', phone: '1-671' , suggested: 0 },
	{ code: 'GW', label: 'Guinea-Bissau', phone: '245' , suggested: 0 },
	{ code: 'GY', label: 'Guyana', phone: '592' , suggested: 0 },
	{ code: 'HK', label: 'Hong Kong', phone: '852' , suggested: 0 },
	{ code: 'HM', label: 'Heard Island and McDonald Islands', phone: '672' , suggested: 0 },
	{ code: 'HN', label: 'Honduras', phone: '504' , suggested: 0 },
	{ code: 'HR', label: 'Croatia', phone: '385' , suggested: 0 },
	{ code: 'HT', label: 'Haiti', phone: '509' , suggested: 0 },
	{ code: 'HU', label: 'Hungary', phone: '36' , suggested: 0 },
	{ code: 'ID', label: 'Indonesia', phone: '62' , suggested: 0 },
	{ code: 'IE', label: 'Ireland', phone: '353' , suggested: 0 },
	{ code: 'IL', label: 'Israel', phone: '972' , suggested: 0 },
	{ code: 'IM', label: 'Isle of Man', phone: '44' , suggested: 0 },
	{ code: 'IN', label: 'India', phone: '91' , suggested: 0 },
	{ code: 'IO', label: 'British Indian Ocean Territory', phone: '246' , suggested: 0 },
	{ code: 'IQ', label: 'Iraq', phone: '964' , suggested: 0 },
	{ code: 'IR', label: 'Iran, Islamic Republic of', phone: '98' , suggested: 0 },
	{ code: 'IS', label: 'Iceland', phone: '354' , suggested: 0 },
	{ code: 'IT', label: 'Italy', phone: '39' , suggested: 0 },
	{ code: 'JE', label: 'Jersey', phone: '44' , suggested: 0 },
	{ code: 'JM', label: 'Jamaica', phone: '1-876' , suggested: 0 },
	{ code: 'JO', label: 'Jordan', phone: '962' , suggested: 0 },
	{ code: 'JP', label: 'Japan', phone: '81', suggested: 0 },
	{ code: 'KE', label: 'Kenya', phone: '254' , suggested: 0 },
	{ code: 'KG', label: 'Kyrgyzstan', phone: '996' , suggested: 0 },
	{ code: 'KH', label: 'Cambodia', phone: '855' , suggested: 0 },
	{ code: 'KI', label: 'Kiribati', phone: '686' , suggested: 0 },
	{ code: 'KM', label: 'Comoros', phone: '269' , suggested: 0 },
	{ code: 'KN', label: 'Saint Kitts and Nevis', phone: '1-869' , suggested: 0 },
	{
		code: 'KP',
		label: "Korea, Democratic People's Republic of",
		phone: '850',
		suggested: 0
	},
	{ code: 'KR', label: 'Korea, Republic of', phone: '82' , suggested: 0 },
	{ code: 'KW', label: 'Kuwait', phone: '965' , suggested: 0 },
	{ code: 'KY', label: 'Cayman Islands', phone: '1-345' , suggested: 0 },
	{ code: 'KZ', label: 'Kazakhstan', phone: '7' , suggested: 0 },
	{ code: 'LA', label: "Lao People's Democratic Republic", phone: '856' , suggested: 0 },
	{ code: 'LB', label: 'Lebanon', phone: '961' , suggested: 0 },
	{ code: 'LC', label: 'Saint Lucia', phone: '1-758' , suggested: 0 },
	{ code: 'LI', label: 'Liechtenstein', phone: '423' , suggested: 0 },
	{ code: 'LK', label: 'Sri Lanka', phone: '94' , suggested: 0 },
	{ code: 'LR', label: 'Liberia', phone: '231' , suggested: 0 },
	{ code: 'LS', label: 'Lesotho', phone: '266' , suggested: 0 },
	{ code: 'LT', label: 'Lithuania', phone: '370' , suggested: 0 },
	{ code: 'LU', label: 'Luxembourg', phone: '352' , suggested: 0 },
	{ code: 'LV', label: 'Latvia', phone: '371' , suggested: 0 },
	{ code: 'LY', label: 'Libya', phone: '218' , suggested: 0 },
	{ code: 'MA', label: 'Morocco', phone: '212' , suggested: 0 },
	{ code: 'MC', label: 'Monaco', phone: '377' , suggested: 0 },
	{ code: 'MD', label: 'Moldova, Republic of', phone: '373' , suggested: 0 },
	{ code: 'ME', label: 'Montenegro', phone: '382' , suggested: 0 },
	{ code: 'MF', label: 'Saint Martin (French part)', phone: '590' , suggested: 0 },
	{ code: 'MG', label: 'Madagascar', phone: '261' , suggested: 0 },
	{ code: 'MH', label: 'Marshall Islands', phone: '692' , suggested: 0 },
	{
		code: 'MK',
		label: 'Macedonia, the Former Yugoslav Republic of',
		phone: '389',
		suggested: 0
	},
	{ code: 'ML', label: 'Mali', phone: '223' , suggested: 0 },
	{ code: 'MM', label: 'Myanmar', phone: '95' , suggested: 0 },
	{ code: 'MN', label: 'Mongolia', phone: '976' , suggested: 0 },
	{ code: 'MO', label: 'Macao', phone: '853' , suggested: 0 },
	{ code: 'MP', label: 'Northern Mariana Islands', phone: '1-670' , suggested: 0 },
	{ code: 'MQ', label: 'Martinique', phone: '596' , suggested: 0 },
	{ code: 'MR', label: 'Mauritania', phone: '222' , suggested: 0 },
	{ code: 'MS', label: 'Montserrat', phone: '1-664' , suggested: 0 },
	{ code: 'MT', label: 'Malta', phone: '356' , suggested: 0 },
	{ code: 'MU', label: 'Mauritius', phone: '230' , suggested: 0 },
	{ code: 'MV', label: 'Maldives', phone: '960' , suggested: 0 },
	{ code: 'MW', label: 'Malawi', phone: '265' , suggested: 0 },
	{ code: 'MX', label: 'Mexico', phone: '52' , suggested: 0 },
	{ code: 'MY', label: 'Malaysia', phone: '60' , suggested: 0 },
	{ code: 'MZ', label: 'Mozambique', phone: '258' , suggested: 0 },
	{ code: 'NA', label: 'Namibia', phone: '264' , suggested: 0 },
	{ code: 'NC', label: 'New Caledonia', phone: '687' , suggested: 0 },
	{ code: 'NE', label: 'Niger', phone: '227' , suggested: 0 },
	{ code: 'NF', label: 'Norfolk Island', phone: '672' , suggested: 0 },
	{ code: 'NG', label: 'Nigeria', phone: '234' , suggested: 0 },
	{ code: 'NI', label: 'Nicaragua', phone: '505' , suggested: 0 },
	{ code: 'NL', label: 'Netherlands', phone: '31' , suggested: 0 },
	{ code: 'NO', label: 'Norway', phone: '47' , suggested: 0 },
	{ code: 'NP', label: 'Nepal', phone: '977' , suggested: 0 },
	{ code: 'NR', label: 'Nauru', phone: '674' , suggested: 0 },
	{ code: 'NU', label: 'Niue', phone: '683' , suggested: 0 },
	{ code: 'NZ', label: 'New Zealand', phone: '64' , suggested: 0 },
	{ code: 'OM', label: 'Oman', phone: '968' , suggested: 0 },
	{ code: 'PA', label: 'Panama', phone: '507' , suggested: 0 },
	{ code: 'PE', label: 'Peru', phone: '51' , suggested: 0 },
	{ code: 'PF', label: 'French Polynesia', phone: '689' , suggested: 0 },
	{ code: 'PG', label: 'Papua New Guinea', phone: '675' , suggested: 0 },
	{ code: 'PH', label: 'Philippines', phone: '63' , suggested: 0 },
	{ code: 'PK', label: 'Pakistan', phone: '92' , suggested: 0 },
	{ code: 'PL', label: 'Poland', phone: '48' , suggested: 0 },
	{ code: 'PM', label: 'Saint Pierre and Miquelon', phone: '508' , suggested: 0 },
	{ code: 'PN', label: 'Pitcairn', phone: '870' , suggested: 0 },
	{ code: 'PR', label: 'Puerto Rico', phone: '1' , suggested: 0 },
	{ code: 'PS', label: 'Palestine, State of', phone: '970' , suggested: 0 },
	{ code: 'PT', label: 'Portugal', phone: '351' , suggested: 0 },
	{ code: 'PW', label: 'Palau', phone: '680' , suggested: 0 },
	{ code: 'PY', label: 'Paraguay', phone: '595' , suggested: 0 },
	{ code: 'QA', label: 'Qatar', phone: '974' , suggested: 0 },
	{ code: 'RE', label: 'Reunion', phone: '262' , suggested: 0 },
	{ code: 'RO', label: 'Romania', phone: '40' , suggested: 0 },
	{ code: 'RS', label: 'Serbia', phone: '381' , suggested: 0 },
	{ code: 'RU', label: 'Russian Federation', phone: '7' , suggested: 0 },
	{ code: 'RW', label: 'Rwanda', phone: '250' , suggested: 0 },
	{ code: 'SA', label: 'Saudi Arabia', phone: '966' , suggested: 0 },
	{ code: 'SB', label: 'Solomon Islands', phone: '677' , suggested: 0 },
	{ code: 'SC', label: 'Seychelles', phone: '248' , suggested: 0 },
	{ code: 'SD', label: 'Sudan', phone: '249' , suggested: 0 },
	{ code: 'SE', label: 'Sweden', phone: '46' , suggested: 0 },
	{ code: 'SG', label: 'Singapore', phone: '65' , suggested: 0 },
	{ code: 'SH', label: 'Saint Helena', phone: '290' , suggested: 0 },
	{ code: 'SI', label: 'Slovenia', phone: '386' , suggested: 0 },
	{ code: 'SJ', label: 'Svalbard and Jan Mayen', phone: '47' , suggested: 0 },
	{ code: 'SK', label: 'Slovakia', phone: '421' , suggested: 0 },
	{ code: 'SL', label: 'Sierra Leone', phone: '232' , suggested: 0 },
	{ code: 'SM', label: 'San Marino', phone: '378' , suggested: 0 },
	{ code: 'SN', label: 'Senegal', phone: '221' , suggested: 0 },
	{ code: 'SO', label: 'Somalia', phone: '252' , suggested: 0 },
	{ code: 'SR', label: 'Suriname', phone: '597' , suggested: 0 },
	{ code: 'SS', label: 'South Sudan', phone: '211' , suggested: 0 },
	{ code: 'ST', label: 'Sao Tome and Principe', phone: '239' , suggested: 0 },
	{ code: 'SV', label: 'El Salvador', phone: '503' , suggested: 0 },
	{ code: 'SX', label: 'Sint Maarten (Dutch part)', phone: '1-721' , suggested: 0 },
	{ code: 'SY', label: 'Syrian Arab Republic', phone: '963' , suggested: 0 },
	{ code: 'SZ', label: 'Swaziland', phone: '268' , suggested: 0 },
	{ code: 'TC', label: 'Turks and Caicos Islands', phone: '1-649' , suggested: 0 },
	{ code: 'TD', label: 'Chad', phone: '235' , suggested: 0 },
	{ code: 'TF', label: 'French Southern Territories', phone: '262' , suggested: 0 },
	{ code: 'TG', label: 'Togo', phone: '228' , suggested: 0 },
	{ code: 'TH', label: 'Thailand', phone: '66' , suggested: 0 },
	{ code: 'TJ', label: 'Tajikistan', phone: '992' , suggested: 0 },
	{ code: 'TK', label: 'Tokelau', phone: '690' , suggested: 0 },
	{ code: 'TL', label: 'Timor-Leste', phone: '670' , suggested: 0 },
	{ code: 'TM', label: 'Turkmenistan', phone: '993' , suggested: 0 },
	{ code: 'TN', label: 'Tunisia', phone: '216' , suggested: 0 },
	{ code: 'TO', label: 'Tonga', phone: '676' , suggested: 0 },
	{ code: 'TR', label: 'Turkey', phone: '90' , suggested: 0 },
	{ code: 'TT', label: 'Trinidad and Tobago', phone: '1-868' , suggested: 0 },
	{ code: 'TV', label: 'Tuvalu', phone: '688' , suggested: 0 },
	{ code: 'TW', label: 'Taiwan, Province of China', phone: '886' , suggested: 0 },
	{ code: 'TZ', label: 'United Republic of Tanzania', phone: '255' , suggested: 0 },
	{ code: 'UA', label: 'Ukraine', phone: '380' , suggested: 0 },
	{ code: 'UG', label: 'Uganda', phone: '256' , suggested: 0 },
	{ code: 'US', label: 'United States', phone: '1', suggested: 0 },
	{ code: 'UY', label: 'Uruguay', phone: '598' , suggested: 0 },
	{ code: 'UZ', label: 'Uzbekistan', phone: '998' , suggested: 0 },
	{ code: 'VA', label: 'Holy See (Vatican City State)', phone: '379' , suggested: 0 },
	{ code: 'VC', label: 'Saint Vincent and the Grenadines', phone: '1-784' , suggested: 0 },
	{ code: 'VE', label: 'Venezuela', phone: '58' , suggested: 0 },
	{ code: 'VG', label: 'British Virgin Islands', phone: '1-284' , suggested: 0 },
	{ code: 'VI', label: 'US Virgin Islands', phone: '1-340' , suggested: 0 },
	{ code: 'VN', label: 'Vietnam', phone: '84' , suggested: 0 },
	{ code: 'VU', label: 'Vanuatu', phone: '678' , suggested: 0 },
	{ code: 'WF', label: 'Wallis and Futuna', phone: '681' , suggested: 0 },
	{ code: 'WS', label: 'Samoa', phone: '685' , suggested: 0 },
	{ code: 'XK', label: 'Kosovo', phone: '383' , suggested: 0 },
	{ code: 'YE', label: 'Yemen', phone: '967' , suggested: 0 },
	{ code: 'YT', label: 'Mayotte', phone: '262' , suggested: 0 },
	{ code: 'ZA', label: 'South Africa', phone: '27' , suggested: 0 },
	{ code: 'ZM', label: 'Zambia', phone: '260' , suggested: 0 },
	{ code: 'ZW', label: 'Zimbabwe', phone: '263' , suggested: 0 },
];

export const languages = [
	{ label: 'Abkhazian', code: 'ab' , suggested: 0 },
	{ label: 'Afar', code: 'aa' , suggested: 0 },
	{ label: 'Afrikaans', code: 'af' , suggested: 0 },
	{ label: 'Akan', code: 'ak' , suggested: 0 },
	{ label: 'Albanian', code: 'sq' , suggested: 0 },
	{ label: 'Amharic', code: 'am' , suggested: 0 },
	{ label: 'Arabic', code: 'ar' , suggested: 0 },
	{ label: 'Aragonese', code: 'an' , suggested: 0 },
	{ label: 'Armenian', code: 'hy' , suggested: 0 },
	{ label: 'Assamese', code: 'as' , suggested: 0 },
	{ label: 'Avaric', code: 'av' , suggested: 0 },
	{ label: 'Avestan', code: 'ae' , suggested: 0 },
	{ label: 'Aymara', code: 'ay' , suggested: 0 },
	{ label: 'Azerbaijani', code: 'az' , suggested: 0 },
	{ label: 'Bambara', code: 'bm' , suggested: 0 },
	{ label: 'Bashkir', code: 'ba' , suggested: 0 },
	{ label: 'Basque', code: 'eu' , suggested: 0 },
	{ label: 'Belarusian', code: 'be' , suggested: 0 },
	{ label: 'Bengali (Bangla)', code: 'bn' , suggested: 0 },
	{ label: 'Bihari', code: 'bh' , suggested: 0 },
	{ label: 'Bislama', code: 'bi' , suggested: 0 },
	{ label: 'Bosnian', code: 'bs' , suggested: 0 },
	{ label: 'Breton', code: 'br' , suggested: 0 },
	{ label: 'Bulgarian', code: 'bg' , suggested: 0 },
	{ label: 'Burmese', code: 'my' , suggested: 0 },
	{ label: 'Catalan', code: 'ca' , suggested: 0 },
	{ label: 'Chamorro', code: 'ch' , suggested: 0 },
	{ label: 'Chechen', code: 'ce' , suggested: 0 },
	{ label: 'Chichewa, Chewa, Nyanja', code: 'ny' , suggested: 0 },
	{ label: 'Chinese', code: 'zh' , suggested: 0 },
	{ label: 'Chinese (Simplified)', code: 'zh-Hans' , suggested: 0 },
	{ label: 'Chinese (Traditional)', code: 'zh-Hant' , suggested: 0 },
	{ label: 'Chuvash', code: 'cv' , suggested: 0 },
	{ label: 'Cornish', code: 'kw' , suggested: 0 },
	{ label: 'Corsican', code: 'co' , suggested: 0 },
	{ label: 'Cree', code: 'cr' , suggested: 0 },
	{ label: 'Croatian', code: 'hr' , suggested: 0 },
	{ label: 'Czech', code: 'cs' , suggested: 0 },
	{ label: 'Danish', code: 'da' , suggested: 0 },
	{ label: 'Divehi, Dhivehi, Maldivian', code: 'dv' , suggested: 0 },
	{ label: 'Dutch', code: 'nl' , suggested: 0 },
	{ label: 'Dzongkha', code: 'dz' , suggested: 0 },
	{ label: 'English', code: 'en' , suggested: 0 },
	{ label: 'Esperanto', code: 'eo' , suggested: 0 },
	{ label: 'Estonian', code: 'et' , suggested: 0 },
	{ label: 'Ewe', code: 'ee' , suggested: 0 },
	{ label: 'Faroese', code: 'fo' , suggested: 0 },
	{ label: 'Fijian', code: 'fj' , suggested: 0 },
	{ label: 'Finnish', code: 'fi' , suggested: 0 },
	{ label: 'French', code: 'fr' , suggested: 2 },
	{ label: 'Fula, Fulah, Pulaar, Pular', code: 'ff' , suggested: 0 },
	{ label: 'Galician', code: 'gl' , suggested: 0 },
	{ label: 'Gaelic (Scottish)', code: 'gd' , suggested: 0 },
	{ label: 'Gaelic (Manx)', code: 'gv' , suggested: 0 },
	{ label: 'Georgian', code: 'ka' , suggested: 0 },
	{ label: 'German', code: 'de' , suggested: 1 },
	{ label: 'Greek', code: 'el' , suggested: 0 },
	{ label: 'Greenlandic', code: 'kl' , suggested: 0 },
	{ label: 'Guarani', code: 'gn' , suggested: 0 },
	{ label: 'Gujarati', code: 'gu' , suggested: 0 },
	{ label: 'Haitian Creole', code: 'ht' , suggested: 0 },
	{ label: 'Hausa', code: 'ha' , suggested: 0 },
	{ label: 'Hebrew', code: 'he' , suggested: 0 },
	{ label: 'Herero', code: 'hz' , suggested: 0 },
	{ label: 'Hindi', code: 'hi' , suggested: 0 },
	{ label: 'Hiri Motu', code: 'ho' , suggested: 0 },
	{ label: 'Hungarian', code: 'hu' , suggested: 0 },
	{ label: 'Icelandic', code: 'is' , suggested: 0 },
	{ label: 'Ido', code: 'io' , suggested: 0 },
	{ label: 'Igbo', code: 'ig' , suggested: 0 },
	{ label: 'Indonesian', code: 'id, in' , suggested: 0 },
	{ label: 'Interlingua', code: 'ia' , suggested: 0 },
	{ label: 'Interlingue', code: 'ie' , suggested: 0 },
	{ label: 'Inuktitut', code: 'iu' , suggested: 0 },
	{ label: 'Inupiak', code: 'ik' , suggested: 0 },
	{ label: 'Irish', code: 'ga' , suggested: 0 },
	{ label: 'Italian', code: 'it' , suggested: 0 },
	{ label: 'Japanese', code: 'ja' , suggested: 0 },
	{ label: 'Javanese', code: 'jv' , suggested: 0 },
	{ label: 'Kalaallisut, Greenlandic', code: 'kl' , suggested: 0 },
	{ label: 'Kannada', code: 'kn' , suggested: 0 },
	{ label: 'Kanuri', code: 'kr' , suggested: 0 },
	{ label: 'Kashmiri', code: 'ks' , suggested: 0 },
	{ label: 'Kazakh', code: 'kk' , suggested: 0 },
	{ label: 'Khmer', code: 'km' , suggested: 0 },
	{ label: 'Kikuyu', code: 'ki' , suggested: 0 },
	{ label: 'Kinyarwanda (Rwanda)', code: 'rw' , suggested: 0 },
	{ label: 'Kirundi', code: 'rn' , suggested: 0 },
	{ label: 'Kyrgyz', code: 'ky' , suggested: 0 },
	{ label: 'Komi', code: 'kv' , suggested: 0 },
	{ label: 'Kongo', code: 'kg' , suggested: 0 },
	{ label: 'Korean', code: 'ko' , suggested: 0 },
	{ label: 'Kurdish', code: 'ku' , suggested: 0 },
	{ label: 'Kwanyama', code: 'kj' , suggested: 0 },
	{ label: 'Lao', code: 'lo' , suggested: 0 },
	{ label: 'Latin', code: 'la' , suggested: 0 },
	{ label: 'Latvian (Lettish)', code: 'lv' , suggested: 0 },
	{ label: 'Limburgish ( Limburger)', code: 'li' , suggested: 0 },
	{ label: 'Lingala', code: 'ln' , suggested: 0 },
	{ label: 'Lithuanian', code: 'lt' , suggested: 0 },
	{ label: 'Luga-Katanga', code: 'lu' , suggested: 0 },
	{ label: 'Luganda, Ganda', code: 'lg' , suggested: 0 },
	{ label: 'Luxembourgish', code: 'lb' , suggested: 0 },
	{ label: 'Manx', code: 'gv' , suggested: 0 },
	{ label: 'Macedonian', code: 'mk' , suggested: 0 },
	{ label: 'Malagasy', code: 'mg' , suggested: 0 },
	{ label: 'Malay', code: 'ms' , suggested: 0 },
	{ label: 'Malayalam', code: 'ml' , suggested: 0 },
	{ label: 'Maltese', code: 'mt' , suggested: 0 },
	{ label: 'Maori', code: 'mi' , suggested: 0 },
	{ label: 'Marathi', code: 'mr' , suggested: 0 },
	{ label: 'Marshallese', code: 'mh' , suggested: 0 },
	{ label: 'Moldavian', code: 'mo' , suggested: 0 },
	{ label: 'Mongolian', code: 'mn' , suggested: 0 },
	{ label: 'Nauru', code: 'na' , suggested: 0 },
	{ label: 'Navajo', code: 'nv' , suggested: 0 },
	{ label: 'Ndonga', code: 'ng' , suggested: 0 },
	{ label: 'Northern Ndebele', code: 'nd' , suggested: 0 },
	{ label: 'Nepali', code: 'ne' , suggested: 0 },
	{ label: 'Norwegian', code: 'no' , suggested: 0 },
	{ label: 'Norwegian bokmål', code: 'nb' , suggested: 0 },
	{ label: 'Norwegian nynorsk', code: 'nn' , suggested: 0 },
	{ label: 'Nuosu', code: 'ii' , suggested: 0 },
	{ label: 'Occitan', code: 'oc' , suggested: 0 },
	{ label: 'Ojibwe', code: 'oj' , suggested: 0 },
	{ label: 'Old Church Slavonic, Old Bulgarian', code: 'cu' , suggested: 0 },
	{ label: 'Oriya', code: 'or' , suggested: 0 },
	{ label: 'Oromo (Afaan Oromo)', code: 'om' , suggested: 0 },
	{ label: 'Ossetian', code: 'os' , suggested: 0 },
	{ label: 'Pāli', code: 'pi' , suggested: 0 },
	{ label: 'Pashto, Pushto', code: 'ps' , suggested: 0 },
	{ label: 'Persian (Farsi)', code: 'fa' , suggested: 0 },
	{ label: 'Polish', code: 'pl' , suggested: 0 },
	{ label: 'Portuguese', code: 'pt' , suggested: 0 },
	{ label: 'Punjabi (Eastern)', code: 'pa' , suggested: 0 },
	{ label: 'Quechua', code: 'qu' , suggested: 0 },
	{ label: 'Romansh', code: 'rm' , suggested: 0 },
	{ label: 'Romanian', code: 'ro' , suggested: 0 },
	{ label: 'Russian', code: 'ru' , suggested: 0 },
	{ label: 'Sami', code: 'se' , suggested: 0 },
	{ label: 'Samoan', code: 'sm' , suggested: 0 },
	{ label: 'Sango', code: 'sg' , suggested: 0 },
	{ label: 'Sanskrit', code: 'sa' , suggested: 0 },
	{ label: 'Serbian', code: 'sr' , suggested: 0 },
	{ label: 'Serbo-Croatian', code: 'sh' , suggested: 0 },
	{ label: 'Sesotho', code: 'st' , suggested: 0 },
	{ label: 'Setswana', code: 'tn' , suggested: 0 },
	{ label: 'Shona', code: 'sn' , suggested: 0 },
	{ label: 'Sichuan Yi', code: 'ii' , suggested: 0 },
	{ label: 'Sindhi', code: 'sd' , suggested: 0 },
	{ label: 'Sinhalese', code: 'si' , suggested: 0 },
	{ label: 'Siswati', code: 'ss' , suggested: 0 },
	{ label: 'Slovak', code: 'sk' , suggested: 0 },
	{ label: 'Slovenian', code: 'sl' , suggested: 0 },
	{ label: 'Somali', code: 'so' , suggested: 0 },
	{ label: 'Southern Ndebele', code: 'nr' , suggested: 0 },
	{ label: 'Spanish', code: 'es' , suggested: 0 },
	{ label: 'Sundanese', code: 'su' , suggested: 0 },
	{ label: 'Swahili (Kiswahili)', code: 'sw' , suggested: 0 },
	{ label: 'Swati', code: 'ss' , suggested: 0 },
	{ label: 'Swedish', code: 'sv' , suggested: 0 },
	{ label: 'Tagalog', code: 'tl' , suggested: 0 },
	{ label: 'Tahitian', code: 'ty' , suggested: 0 },
	{ label: 'Tajik', code: 'tg' , suggested: 0 },
	{ label: 'Tamil', code: 'ta' , suggested: 0 },
	{ label: 'Tatar', code: 'tt' , suggested: 0 },
	{ label: 'Telugu', code: 'te' , suggested: 0 },
	{ label: 'Thai', code: 'th' , suggested: 0 },
	{ label: 'Tibetan', code: 'bo' , suggested: 0 },
	{ label: 'Tigrinya', code: 'ti' , suggested: 0 },
	{ label: 'Tonga', code: 'to' , suggested: 0 },
	{ label: 'Tsonga', code: 'ts' , suggested: 0 },
	{ label: 'Turkish', code: 'tr' , suggested: 0 },
	{ label: 'Turkmen', code: 'tk' , suggested: 0 },
	{ label: 'Twi', code: 'tw' , suggested: 0 },
	{ label: 'Uyghur', code: 'ug' , suggested: 0 },
	{ label: 'Ukrainian', code: 'uk' , suggested: 0 },
	{ label: 'Urdu', code: 'ur' , suggested: 0 },
	{ label: 'Uzbek', code: 'uz' , suggested: 0 },
	{ label: 'Venda', code: 've' , suggested: 0 },
	{ label: 'Vietnamese', code: 'vi' , suggested: 0 },
	{ label: 'Volapük', code: 'vo' , suggested: 0 },
	{ label: 'Wallon', code: 'wa' , suggested: 0 },
	{ label: 'Welsh', code: 'cy' , suggested: 0 },
	{ label: 'Wolof', code: 'wo' , suggested: 0 },
	{ label: 'Western Frisian', code: 'fy' , suggested: 0 },
	{ label: 'Xhosa', code: 'xh' , suggested: 0 },
	{ label: 'Yiddish', code: 'yi, ji' , suggested: 0 },
	{ label: 'Yoruba', code: 'yo' , suggested: 0 },
	{ label: 'Zhuang, Chuang', code: 'za' , suggested: 0 },
	{ label: 'Zulu', code: 'zu' , suggested: 0 },
];

export const countriesFiltered = countries.sort((a,b) => b.suggested - a.suggested)

export const languagesFiltered = languages.sort((a,b) => b.suggested - a.suggested)